<script setup lang="ts">
import { computed, withDefaults } from 'vue'
import colors from 'tailwindcss/colors'

interface PropTypes {
  color?: string
  bgColor?: string
  height?: string
  max?: number
  rounded?: boolean
  roundedProgress?: boolean
  value?: number
}

const props = withDefaults(defineProps<PropTypes>(), {
  class: '',
  height: 'full',
  color: 'green-500',
  bgColor: 'bg-gray-200 dark:bg-gray-700',
  max: 100,
  rounded: false,
  roundedProgress: false,
  value: 0,
})

const color = computed<string>(() => {
  const colorArr = props.color.split('-')
  if (colorArr.length === 2) {
    const [base, modifier] = colorArr
    const twColor = colors?.[base]?.[modifier]
    if (twColor !== undefined) return twColor
  }
  return color
})

const progress = computed<number>(() => {
  const max = props.max === 0 ? 1 : props.max
  return Math.round((props.value / max) * 100)
})

const containerClass = computed<string>(() => {
  let str = `relative h-${props.height} w-full ${props.bgColor} overflow-hidden`
  if (props.rounded === true) str += ' rounded-full'
  return str
})

const progressClass = computed<string>(() => {
  let str = `progress-bar-inner !h-full bg-${props.color} `
  if (props.roundedProgress === true) str += ' rounded-full'
  return str
})
</script>

<template>
  <div :class="containerClass">
    <div :class="progressClass"></div>
  </div>
</template>

<style>
.progress-bar-inner {
  width: v-bind('`${progress}%`');
}
</style>
